import { ref } from 'vue';
import useProvideFactory from '../dumb/useProvideFactory';
import { useSlideoutStore } from '@nuxt-common/atomic-ui/app/stores/useSlideoutStore';

export const ACCOUNT_SLIDE_OUT_REPOSITORY = Symbol('ACCOUNT_SLIDEOUT_REPOSITORY');

export function getAccountSlideOutSharedState() {
  return ref('');
}

export function useAccountSlideOutProvide(useAsInject) {
  return useProvideFactory({
    key: ACCOUNT_SLIDE_OUT_REPOSITORY,
    factory: getAccountSlideOutSharedState,
    useAsInject,
  });
}

export default function useAccountSlideout() {
  const slideoutId = useAccountSlideOutProvide(true);

  function init(id) {
    slideoutId.value = id;
  }

  function toggleSlideout() {
    const slideoutStore = useSlideoutStore();
    slideoutStore.toggle(slideoutId.value);
  }

  function openAccountSlideout() {
    toggleSlideout();
  }

  return {
    slideoutId,
    init,
    openAccountSlideout,
    toggleSlideout,
  };
}
